export class PetParent {
    constructor(public readonly email: string) {}
}
